import React, { useState } from "react";
import { useFormContext, useFieldArray } from "react-hook-form";
import { Button } from "antd"; // Using Ant Design Input for better UI consistency
import Select from "react-select";
import { Delete, PlusCircle, Trash2 } from "react-feather";
import { format } from "date-fns";
import Input from "Components/UI/Input";
import dayjs from "dayjs";
import ImageUploader from "Components/UI/ImageUploder";
import ImageCropper from "Components/UI/Image/ImageCropper";
import { useFormattedEmpContractOption } from "core/Operations/formattedOption/useFormattedEmployeeOptions";
const activestatus = [
  { id: true, label: "Yes", value: true },
  { id: false, label: "No", value: false },
];
const ContractDetails = () => {
  const {
    control,
    register,
    setValue,
    getValues,
    watch,
    formState: { errors },
    trigger,
  } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "contractDetails",
  });

  const contractDetails = watch("contractDetails") || [];

  const contractTypeOptions = useFormattedEmpContractOption(
    watch("companyCode")
  );

  const addExperienceRow = () => {
    const newContract = {
      code: 0,
      companyCode: watch("companyCode"),
      employeeCode: watch("employeeCode"),
      contractType: "",
      duration: "",
      contractStartDate: "",
      contractExpiryDate: "",
      issuedBy: "",
      status: "",
      frontImage: "",
      backImage: "",
      createUser: watch("createUser"),
      modifyUser: watch("modifyUser"),
      createDate: watch("createDate"),
      modifyDate: watch("modifyDate"),
      isActive: true,
    };

    setValue("contractDetails", [...contractDetails, newContract]);
  };

  const removeExperience = (index) => {
    const updatedExperience = contractDetails.filter((_, i) => i !== index);
    setValue("contractDetails", updatedExperience);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <h4></h4>
        <button
          className="btn btn-secondary btn-sm "
          type="button"
          onClick={addExperienceRow}
        >
          <PlusCircle className="me-2" />
          Add Row
        </button>
      </div>
      <div className="table-responsive" style={{ minHeight: "250px" }}>
        <table className="table custom-table table-nowrap mb-0">
          <thead>
            <tr>
              <th>-</th>
              <th>Contract Type</th>
              <th>Contract Start Date</th>
              <th>Contract End Date</th>
              <th>Duration</th>
              <th>Issued By</th>
              <th>Contract Status</th>
              <th>Front Image</th>
              <th>Back Image</th>
              <th>Active Status</th>
            </tr>
          </thead>

          <tbody>
            {contractDetails.map((data, index) => {
              return (
                <tr key={index}>
                  <td>
                    <Button type="danger" onClick={() => remove(index)}>
                      <Trash2 />
                    </Button>
                  </td>
                  {/* <td>
                    <Input
                      name={`contractDetails[${index}].contractType`}
                      type="text"
                      placeholder="Course Name"
                      className={`form-control ${
                        errors?.contractDetails?.[index]?.courseName
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td> */}
                  <td>
                    <Input
                      name={`contractDetails[${index}].contractType`}
                      type="commonSelect"
                      placeholder=""
                      className={`form-control ${
                        errors.contractDetails?.[index]?.contractType
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName="form-label"
                      optionData={contractTypeOptions}
                      required={true}
                      requiredMessage="Active Status is required"
                      onChange={(selectedOption) => {
                        setValue(
                          "contractDetails[${index}].contractType",
                          selectedOption
                        );
                        trigger("contractDetails[${index}].contractType");
                      }}
                      defaultValue={watch(
                        "contractDetails[${index}].contractType"
                      )}
                      style={{ width: "200px" }}
                    />
                  </td>
                  <td>
                    <Input
                      name={`contractDetails[${index}].contractStartDate`}
                      type="date"
                      placeholder="Contact Start Date"
                      className={`form-control ${
                        errors?.contractDetails?.[index]?.contractStartDate
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      defaultValue={
                        dayjs(
                          watch(`contractDetails[${index}].contractStartDate`),
                          "YYYY-MM-DD"
                        ) || ""
                      }
                      dateFormat="YYYY-MM-DD"
                      style={{ width: "200px" }}
                    />
                  </td>
                  <td>
                    <Input
                      name={`contractDetails[${index}].contractExpiryDate`}
                      type="date"
                      placeholder="Contact Expiry Date"
                      className={`form-control ${
                        errors?.contractDetails?.[index]?.contractExpiryDate
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      defaultValue={
                        dayjs(
                          watch(`contractDetails[${index}].contractExpiryDate`),
                          "YYYY-MM-DD"
                        ) || ""
                      }
                      dateFormat="YYYY-MM-DD"
                      style={{ width: "200px" }}
                    />
                  </td>
                  <td>
                    <Input
                      name={`contractDetails[${index}].duration`}
                      type="text"
                      placeholder="Duration"
                      className={`form-control ${
                        errors?.contractDetails?.[index]?.duration
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>
                  <td>
                    <Input
                      name={`contractDetails[${index}].issuedBy`}
                      type="text"
                      placeholder="Issued By"
                      className={`form-control ${
                        errors?.contractDetails?.[index]?.issuedBy
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>
                  <td>
                    <Input
                      name={`contractDetails[${index}].status`}
                      type="text"
                      placeholder="Contact Status"
                      className={`form-control ${
                        errors?.contractDetails?.[index]?.status
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>

                  <td>
                    <ImageCropper
                      base64Value={watch(
                        `contractDetails[${index}].frontImage`
                      )}
                      setBase64Value={(value) =>
                        setValue(`contractDetails[${index}].frontImage`, value)
                      }
                      id={`frontImage-${index}`}
                    />
                  </td>
                  <td>
                    <ImageCropper
                      base64Value={watch(`contractDetails[${index}].backImage`)}
                      setBase64Value={(value) =>
                        setValue(`contractDetails[${index}].backImage`, value)
                      }
                      id={`backImage-${index}`}
                    />
                  </td>

                  <td>
                    <Input
                      name={`contractDetails[${index}].isActive`}
                      type="commonSelect"
                      placeholder=""
                      className={`form-control ${
                        errors.contractDetails?.[index]?.isActive
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName="form-label"
                      optionData={activestatus}
                      required={true}
                      requiredMessage="Active Status is required"
                      onChange={(selectedOption) => {
                        setValue(
                          "contractDetails[${index}].isActive",
                          selectedOption
                        );
                        trigger("contractDetails[${index}].isActive");
                      }}
                      defaultValue={watch("contractDetails[${index}].isActive")}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ContractDetails;
